import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { withActions } from '../../../../api';
import { updateProductsDispatch } from '../../../../reducers/shops';

import SortProducts from './sortProducts';

import { reorder } from '../other';

const SortModeProducts = (props) => {
    const categories = useSelector(state => state.shops.categories);
    const hiddenCategories = useSelector(state => state.shops.hiddenCategories);
    const language = useSelector(state => state.shops.defaultLanguage);
    const dispatch = useDispatch();

    const [openModal, setOpenModal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [submitData, setSubmitData] = useState(false);
    const [products, setProducts] = useState(null);
    const [categoriesList, setCategoriesList] = useState(null);
    const [activeCategoryId, setActiveCategoryId] = useState(null);
    const [activeProducts, setActiveProducts] = useState(null);

    const handleClose = () => {
        setOpenModal(false);
        setIsSubmit(false);
    };

    const handleClickSubmit = () => {
        setOpenModal(false);
        setIsSubmit(true);
    };

    const getProducts = async () => {
        const data = await props.getProducts();

        if (data && !data.isError && !products) {
            setProducts(data);
        }
    }

    const getActiveProducts = () => {
        let count = 0;
        let sendProducts = [];
        let activeProductsArr = Array.isArray(products)
            ? products
            : Object.values(products || {});

        activeProductsArr = activeProductsArr
            .filter(item => String(item.categoryId || item.menuCategoryId) === String(activeCategoryId))
            .sort((a, b) => a.order > b.order ? 1 : -1);

        activeProductsArr.forEach(item => {
            sendProducts.push({ ...item, order: item.order ? item.order : count + 1 });
            count += 1;
        });

        setActiveProducts(sendProducts);
    }

    const getCategoriesList = () => {
        const categoriesData = Array.isArray(categories)
            ? [...categories]
            : Object.values(categories || {});
        const listData = categoriesData
            .filter(item => item && item.id)
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map(item => ({ id: item.id, name: item.name && item.name[language] }));

        if (listData.length > 0) setCategoriesList(listData);
    }

    useEffect(() => {
        if (isSubmit) {
            handleSubmit(submitData);
            setOpenModal(false);
        };
    }, [isSubmit]);

    useEffect(() => {
        let selectedCategoryId = props.location.pathname;
        selectedCategoryId = selectedCategoryId.split('/');
        selectedCategoryId = selectedCategoryId[selectedCategoryId.length - 1].replace('category', '');
        const categoriesData = Array.isArray(categories)
            ? [...categories]
            : Object.values(categories || {});
        const firstCategory = categoriesData
            .sort((a, b) => (a.order || 0) - (b.order || 0))[0]?.id;

        if (activeCategoryId !== selectedCategoryId) {
            setActiveCategoryId(selectedCategoryId);
            setActiveProducts(null);
        }

        if (products && (String(firstCategory) === String(selectedCategoryId) || selectedCategoryId === ':id')) {
            setActiveCategoryId(firstCategory);
            getActiveProducts();
        }

    }, [activeCategoryId, props.location.pathname, products]);

    useEffect(() => {
        if (!products && activeCategoryId) getProducts();
        if (!activeProducts && activeCategoryId && products) getActiveProducts();
    }, [activeCategoryId, products]);

    useEffect(() => {
        if (!categoriesList && categories) getCategoriesList();
    }, [categoriesList, categories]);

    const onDragEnd = (result) => {
        if (!result.destination) {
          return;
        }

        let data = reorder(
          activeProducts,
          result.source.index,
          result.destination.index,
        );

        let sortData = {};

        data.forEach((item, index) => {
            sortData[item.id] = { id: item.id, order: index + 1 }
        });

        setActiveProducts(data);
        setSubmitData(sortData);
    }

    const clearStateByProducts = () => {
        setIsSubmit(false);
        setProducts(null);
        setActiveProducts(null);
    };

    const applyProductsOrder = (orderData, updatedProducts) => {
        const productsData = Array.isArray(updatedProducts)
            ? updatedProducts
            : Array.isArray(products)
                ? products
                : Object.values(products || {});
        const orderById = Object.values(orderData).reduce((acc, item) => {
            acc[item.id] = item.order;
            return acc;
        }, {});
        const nextProducts = productsData.map(item => ({
            ...item,
            order: orderById[item.id] || item.order,
        }));

        updateProductsDispatch(dispatch, nextProducts);
        setProducts(nextProducts);
        setActiveProducts(
            nextProducts
                .filter(item => String(item.categoryId || item.menuCategoryId) === String(activeCategoryId))
                .sort((a, b) => (a.order || 0) - (b.order || 0))
        );
    };

    const handleSubmit = async (data) => {
        console.log('submit data', data);

        if (!data) {
            clearStateByProducts();
        } else {
            const res = await props.updateProductsSortOrder({
                products: Object.values(data),
            });

            if (res?.isError) {
                console.log('error', res.message);
                clearStateByProducts();
                return;
            }

            applyProductsOrder(data, res?.products);
            clearStateByProducts();
        }
    }

    return (
        <SortProducts
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleClose={handleClose}
            handleClickSubmit={handleClickSubmit}
            categoriesList={categoriesList}
            onDragEnd={onDragEnd}
            activeProducts={activeProducts}
            language={language}
            hiddenCategories={hiddenCategories}
        />
    )
}

export default withActions(withRouter(SortModeProducts));
